<div class="flex w-full flex-1 flex-col">
  <div class="mb-3 flex justify-between gap-2">
    <div class="flex flex-col justify-center overflow-hidden">
      <h4
        class="typo-h4-semibold overflow-hidden text-ellipsis whitespace-nowrap leading-none"
        libHighlight
        [searchTerm]="searchTextToHighlight"
        [text]="participantsString"
        classesToApply="bg-states-orange text-text-white"
      ></h4>
      @if (subject) {
        <h5
          class="typo-h5-medium mt-0.5 overflow-hidden text-ellipsis whitespace-nowrap leading-none"
          libHighlight
          [searchTerm]="searchTextToHighlight"
          [text]="subject"
          classesToApply="bg-states-orange text-text-white"
        ></h5>
      }
    </div>
    <lib-avatars [persons]="participants()" [hasBorderWhenSingle]="false" [size]="30" class="max-h-11 max-w-11"></lib-avatars>
  </div>

  <div
    class="typo-h5-book mb-3 flex items-center gap-1 overflow-hidden leading-none text-text-tertiary"
    [ngClass]="!lastMessage && !dateOfLastMessage && !hasUnreadMessage ? 'justify-end' : 'justify-between'"
  >
    @if (hasUnreadMessage && !daysLeftOfDeletion()) {
      <div class="flex w-[28px] min-w-[28px] justify-center">
        <div class="flex h-4 items-center">
          <div class="h-2 min-h-2 w-2 min-w-2 rounded-full bg-states-red/80"></div>
        </div>
      </div>
    }

    <span class="line-clamp-2 flex-initial overflow-hidden">
      @if (lastMessageSenderFirstName) {
        <span>{{ lastMessageSenderFirstName }}: </span>
      }
      @if (lastMessage) {
        {{ lastMessage }}
      } @else if (hasAttachmentInLastMessage()) {
        {{ 'collab_last_message_attachment' | translate }}
      }
    </span>

    @if (dateOfLastMessage) {
      <div class="ml-auto flex h-fit">
        @if (dateOfLastMessage | dateEquals: 'today') {
          <span class="flex-1 whitespace-nowrap">{{ dateOfLastMessage | date: 'shortTime' }}</span>
        } @else if (dateOfLastMessage | dateEquals: 'yesterday') {
          <span class="flex-1 whitespace-nowrap">{{ 'collab_chat_yesterday' | translate }}</span>
        } @else {
          <span class="flex-1 whitespace-nowrap">{{ dateOfLastMessage | date: 'MM/dd/yy' }}</span>
        }
      </div>
    }
    @if (!isSupportCollab() && (!daysLeftOfDeletion() || deleteCollabAvailable())) {
      <button class="flex h-4 w-4 items-center justify-center" [matMenuTriggerFor]="contextMenu" (click)="onMenuClick($event)">
        <svg-icon class="text-primary-blue" size="sm" key="px-16-more"></svg-icon>
      </button>
    }
  </div>

  <div class="flex w-full justify-between gap-1">
    <div class="rounded-lg bg-background-tag px-2">
      <span class="typo-h5-semibold text-primary-blue">
        {{ (linkedPatient ? 'collab_type_clinical_collab' : 'collab_type_team_collab') | translate }}
      </span>
    </div>

    @if (linkedPatient) {
      <div class="flex items-center gap-1">
        <span class="typo-h5-book">{{ linkedPatient.firstName }} {{ linkedPatient.lastName }}</span>
        <svg-icon key="px-24-chart" size="sm" class="text-primary-blue"></svg-icon>
      </div>
    }
  </div>

  @if (daysLeftOfDeletion()) {
    <div class="typo-h5-book mt-2 leading-none" [ngClass]="daysLeftOfDeletion()! <= 3 ? 'text-states-red' : 'text-text-tertiary'">
      {{ 'collab_delete_collab_days_remaining' | translate: { input1: daysLeftOfDeletion() } }}
    </div>
  }
</div>

<mat-menu #contextMenu="matMenu">
  @if (daysLeftOfDeletion()) {
    <button class="flex justify-between gap-4 px-2 font-medium text-text-primary" (click)="onRecoverCollabClick()">
      <span>{{ 'collab_menu_recover' | translate }}</span>
      <svg-icon class="shrink-0" size="md" key="px-24-undo"></svg-icon>
    </button>
    <hr class="border-text-white" />
    <button class="flex justify-between gap-4 px-2 font-medium text-states-red" (click)="onDeleteCollabClick()">
      <span>{{ 'collab_menu_delete_immidiately' | translate }}</span>
      <svg-icon class="shrink-0" size="md" key="px-16-delete"></svg-icon>
    </button>
  } @else {
    @if (isGroupCollab()) {
      <button class="flex justify-between gap-4 px-2 font-medium text-text-primary" (click)="onLeaveCollabClick()">
        <span>{{ 'collab_menu_leave' | translate }}</span>
        <svg-icon class="shrink-0" size="md" key="px-24-logout"></svg-icon>
      </button>
    }
    @if (deleteCollabAvailable()) {
      <hr class="border-text-white" />
      <button class="flex justify-between gap-4 px-2 font-medium text-states-red" (click)="onDeleteCollabClick()">
        <span>{{ 'collab_menu_delete' | translate }}</span>
        <svg-icon class="shrink-0" size="md" key="px-16-delete"></svg-icon>
      </button>
    }
  }
</mat-menu>
